/**
 * @description Get Ledger Account Number relevant to the Bank Account Number
 * @param {string} selectedBankAccNo - From values
 * @param {any} bankAccounts
 */
export const getLedgerAccountNumber = (
  selectedBankAccNo: string, 
  bankAccounts: any[] 
): string => {
  try{
    const bankAccount = bankAccounts.find((bankAccount: any) => bankAccount.accountNo === selectedBankAccNo);
    return bankAccount?.ledgerAccountNumber ?? "";
  } catch (error) {
    return "";
  }
};